import { Controller } from "@hotwired/stimulus";

export default class MaxlengthIndicator extends Controller {
  declare counterTarget : HTMLSpanElement
  declare fieldTarget : HTMLTextAreaElement
  declare hasWarningTarget: boolean
  declare warningTarget: HTMLElement

  static targets = ["counter", "field", "warning"]

  fieldTargetConnected(field: HTMLTextAreaElement) {
    this.updateMaxLengthCounter(field)
  }

  updateCounter() {
    this.updateMaxLengthCounter(this.fieldTarget)
  }

  updateMaxLengthCounter (field: HTMLTextAreaElement | null) {
    if (!field) { return }
    this.counterTarget.innerText = `${field.value.length}/${field.maxLength}`;

    const atLimit = field.value.length >= field.maxLength
    this.counterTarget.classList.toggle('text-danger-emphasis', atLimit)

    if (this.hasWarningTarget) {
      this.warningTarget.hidden = !atLimit
    }
  }
}
